import { getToolsClient } from '@/services/tools'
const toolsAxios = getToolsClient()
const baseEndpoint = '/ibeacon/import'

export const constants = {
  data: {
    iconOptions: [],
  },
}

export const uploadFile = async (data) => {
  let response
  try {
    const res = await toolsAxios({
      method: 'POST',
      url: `${baseEndpoint}`,
      data: data,
    })
    response = res?.data
  } catch (error) {
    response = error.response
  }
  return response
}